import { render, staticRenderFns } from "./SingleWheelOfFortune.vue?vue&type=template&id=737487ee&scoped=true&"
import script from "./SingleWheelOfFortune.vue?vue&type=script&lang=js&"
export * from "./SingleWheelOfFortune.vue?vue&type=script&lang=js&"
import style0 from "./SingleWheelOfFortune.vue?vue&type=style&index=0&id=737487ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737487ee",
  null
  
)

export default component.exports